<div
  *ngIf="visible"
  [@slideInOut]
  class="tw-fixed tw-bottom-4 tw-right-4 tw-z-50 tw-w-80 tw-bg-white tw-rounded-lg tw-shadow dark:tw-shadow-gray-500 tw-border-3 tw-border-solid tw-border-gray-200 dark:tw-bg-gray-800 dark:tw-border-gray-600">
  <div class="tw-p-4">
    <!-- Header with close button -->
    <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
      <h3 class="tw-text-sm tw-font-semibold tw-text-gray-700 dark:tw-text-gray-300 tw-my-0">
        {{getHeadingText()}}
      </h3>

      <button
        mat-icon-button
        class="tw-text-gray-500 dark:tw-text-gray-400 tw-h-6 tw-w-6 tw-min-h-0 tw-p-0 tw-ml-auto"
        (click)="close()"
        aria-label="Close">
        <mat-icon class="tw-text-base">close</mat-icon>
      </button>
    </div>

    <!-- Download info -->
    <div class="tw-flex tw-items-center tw-mb-3">
      <div
        class="tw-flex-shrink-0 tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-relative"
        [ngClass]="getStatusBgClass()">
        <div
          *ngIf="download.status === ReportDeliveryStatus.InProgress"
          class="tw-absolute tw-inset-0 tw-rounded-full">
          <div
            class="tw-w-[92%] tw-h-[92%] tw-rounded-full tw-border-2 tw-border-solid tw-border-blue-500 dark:tw-border-blue-400 tw-border-t-transparent dark:tw-border-t-transparent tw-animate-spin"></div>
        </div>
        <mat-icon [ngClass]="getStatusClass()">{{getStatusIcon()}}</mat-icon>
      </div>
      <div class="tw-ml-3 tw-flex-1">
        <div
          class="tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white tw-break-words"
          [title]="download.scheduled_report_metadata.report_definition.name">
          {{download.scheduled_report_metadata.report_definition.name}}
        </div>
        <!-- <div class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400" *ngIf="download.description">
          {{download.description}}
        </div> -->
      </div>
    </div>

    <!-- Auto-download checkbox -->
    <div
      class="tw-mb-3"
      *ngIf="download.status === ReportDeliveryStatus.InProgress && !isDownloaded">
      <mat-checkbox
        [(ngModel)]="autoDownload"
        class="tw-text-xs tw-text-gray-700 dark:tw-text-gray-300">
        Download when complete
      </mat-checkbox>
    </div>

    <!-- Info alert for completed download without auto-download -->
    <app-alert
      *ngIf="download.status === ReportDeliveryStatus.Complete && !autoDownload && !isDownloaded"
      alertType="info"
      alertStyle="compact"
      hideIcon="true"
      class="tw-mb-1">
      <span class="tw-text-sm">
        Your download is ready. You can find it on
        <a
          [routerLink]="getDownloadsUrl()"
          class="tw-text-blue-500 hover:tw-underline tw-font-semibold">
          Downloads page
        </a>
        and it will also be emailed to you.
      </span>
    </app-alert>

    <!-- Info alert for failed download -->
    <app-alert
      *ngIf="download.status === ReportDeliveryStatus.Failed"
      alertType="error"
      alertStyle="compact"
      hideIcon="true"
      class="tw-mb-1">
      <span class="tw-text-sm"> Something went wrong with this download. Please try again. </span>
    </app-alert>

    <!-- Info alert for scheduled download -->
    <app-alert
      *ngIf="download.status === ReportDeliveryStatus.Scheduled"
      alertType="normal"
      alertStyle="compact"
      hideIcon="true"
      class="tw-mb-1">
      <span class="tw-text-sm"> Your download will start processing soon. </span>
    </app-alert>

    <!-- Info alert for completed download with auto-download -->
    <app-alert
      *ngIf="download.status === ReportDeliveryStatus.Complete && autoDownload && !isDownloaded"
      alertType="info"
      alertStyle="compact"
      hideIcon="true"
      class="tw-mb-1">
      <span class="tw-text-sm">
        Your file has been downloaded. You can also access it on
        <a
          [routerLink]="getDownloadsUrl()"
          class="tw-text-blue-500 hover:tw-underline tw-font-semibold">
          Downloads page
        </a>
        and it will also be emailed to you.
      </span>
    </app-alert>

    <!-- if ready, show download button -->
    <div class="tw-flex tw-items-center tw-justify-end">
      <button
        *ngIf="download.status === ReportDeliveryStatus.Complete && !isDownloaded && !autoDownload"
        mat-stroked-button
        color="primary"
        class="tw-text-xs"
        (click)="downloadFile()">
        <mat-icon class="tw-text-base tw-mr-1 tw-mb-1">download</mat-icon>
        Download
      </button>
    </div>

    <div
      *ngIf="
        download.status === ReportDeliveryStatus.InProgress ||
        download.status === ReportDeliveryStatus.Scheduled
      "
      class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400 tw-p-1">
      This dialog and window can be closed. You'll receive an email when your download is ready.
    </div>
  </div>
</div>
